import { DEVICES } from './../../constants';
import { bindable, ICustomElementViewModel } from 'aurelia';
import './db-skeleton-loader.scss';

export class DbSkeletonLoader implements ICustomElementViewModel {
    @bindable blogpostSkeleton: boolean = false;
    @bindable authorSkeleton: boolean = false;
    @bindable blogsSkeleton: boolean = false;
    @bindable parent: any;
    DEVICES = DEVICES;
}
